module.exports = __webpack_public_path__ + "img/98.28a50791.jpg";